import React, { useState, memo, useEffect, Fragment } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();
export const CourceVenue = memo((props) => {
  const { item } = props;
  // 初期設定
  const [currentCourceVenue, setCurrentCourceVenue] = useState(item);

  const onChangeSurvey = () => setCurrentCourceVenue({ ...currentCourceVenue, is_survey: !currentCourceVenue.is_survey });

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onClickSurveySubmit = (id) => {
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.put(`/agent/cource_venues/${id}/survay`)
    .then(resp => {
      onChangeSurvey();
      notify("success", "Survey Enabled successfully updated!");
    })
    .catch(e => {
      console.log(e.response);
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "Survey Enabled update Error!");
    })
  }

  console.log("currentCourceVenue");
  console.log(currentCourceVenue);
  return (
    <tr>
      <td>{currentCourceVenue.id}</td>
      <td>{currentCourceVenue.venue_id}</td>
      <td>{currentCourceVenue.venue_name}</td>
      <td className={currentCourceVenue.is_survey ? 'bg-secondary bg-opacity-10' : ''}>
        {currentCourceVenue.reservable_at.map(item =>
            <small className='me-2 text-decoration-underline'>{item}</small>
        )}
      </td>
      <td>
        <button onClick={() => onClickSurveySubmit(currentCourceVenue.id)} className={currentCourceVenue.is_survey ? 'btn btn-outline-info mrb-1' : 'btn btn-warning mrb-1'} title="SurVay/NoSurVay">
          <i className={currentCourceVenue.is_survey ? 'fas fa-check' : 'fas fa-times'} />
        </button>
        <a className={ (0 < currentCourceVenue.cvitems_count) ? 'btn btn-outline-primary mrb-1' : 'btn btn-outline-secondary mrb-1'} title="巡回会場の枠設定"
            href={`/agent/cource_venues/${currentCourceVenue.id}/cource_venue_items`}>
          <i className="fas fa-calendar-alt" />
        </a>
    </td>
    </tr>
  );
});
